// Pure at-risk-assessment predicates for the BHI assessment kiosk. CommonJS so
// Jest can require it directly (nav-badge-counts.js is ESM + untestable-via-require
// in this repo); re-exported from nav-badge-counts.js for the chrome shell, and
// imported by the Studio row for its at-risk indicator — one shared predicate.

// Does this patient blob have a risk-flagged (PHQ-9 item-9) assessment that a
// clinician has not yet reviewed? Cleared by riskReviewedAt.
function hasOpenAssessmentRisk(data) {
  const assessments = (data && data.bhi && Array.isArray(data.bhi.assessments)) ? data.bhi.assessments : [];
  return assessments.some((a) => a && a.riskFlag && !a.riskReviewedAt);
}

// Count of patients (rows of { data }) with at least one open at-risk assessment.
function countAtRiskAssessmentBadge(rows) {
  return (rows || []).reduce((n, row) => (hasOpenAssessmentRisk((row && row.data) || {}) ? n + 1 : n), 0);
}

// The ts of every open (unreviewed) at-risk assessment on this patient blob —
// what the clinician "mark reviewed" action POSTs to /data/assessment-review.
function openRiskAssessmentTimestamps(data) {
  const assessments = (data && data.bhi && Array.isArray(data.bhi.assessments)) ? data.bhi.assessments : [];
  return assessments.filter((a) => a && a.riskFlag && !a.riskReviewedAt).map((a) => a.ts);
}

module.exports = { hasOpenAssessmentRisk, countAtRiskAssessmentBadge, openRiskAssessmentTimestamps };
